import { BaseService, Resource } from '@app/core/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { env } from '../../../environments/env';
import { Injectable } from '@angular/core';
import { ResourceType } from '@dwo/enums';
import { CommentDto } from '@app/generated/model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CommentsService extends BaseService {
  constructor(public http: HttpClient) {
    super(http);
  }

  @Resource(ResourceType.LoadMipsComments)
  loadMIPSComments(workOrderId: string): Observable<CommentDto[]> {
    return this.http.get<CommentDto[]>(`${env.get().api.url}/work-orders/${workOrderId}/comments/mips`);
  }

  getCommentsCount(workOrderId: string): Observable<{
    comments: number;
    materialComments: number;
    workLineComments: number;
  }> {
    const url = `${env.get().api.url}/work-orders/${workOrderId}/comments`;

    return this.http.get<CommentDto[]>(url).pipe(
      map((comments) => ({
        comments: comments.length,
        materialComments: comments.filter((c) => c.referenceType === 'MATERIAL').length,
        workLineComments: comments.filter((c) => c.referenceType === 'WORK_LINE').length,
      })),
    );
  }
}
